module.exports = __webpack_public_path__ + "static/media/bg.30155fc4.svg";